// Default authority settings (only 4 supported fields)
export const DEFAULT_AUTHORITY_SETTINGS = {
  enabledAuthorityFields: [
    'contributors.name',
    'subjects.value',
    'series.value',
    'alternativeTitles.alternativeTitle',
  ],
  personalNameAuthoritySource: 'local',
  corporateNameAuthoritySource: 'local',
  conferenceNameAuthoritySource: 'local',
  uniformTitleAuthoritySource: 'local',
  topicalSubjectAuthoritySource: 'local',
  enableAutoCreateAuthority: true,
};

// Available authority field options (only 4 supported fields)
export const AUTHORITY_FIELD_OPTIONS = [
  { value: 'contributors.name', label: 'Contributors' },
  { value: 'subjects.value', label: 'Subjects' },
  { value: 'series.value', label: 'Series' },
  { value: 'alternativeTitles.alternativeTitle', label: 'Alternative Titles' },
];

// Authority types mapping
export const AUTHORITY_TYPE_MAPPING = {
  'contributors.name': 'personalName',
  'subjects.value': 'topicalSubject',
  'series.value': 'uniformTitle',
  'alternativeTitles.alternativeTitle': 'uniformTitle',
};
